export enum PortfolioStatus {
  ACTIVE = 'Active',
  NEW = 'New'
}
